webpackJsonp([491],{

/***/ 1156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "vue-router 路由 | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 2110:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1156),
  /* template */
  __webpack_require__(2572),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/data/vux/home/websites/vux-repo/docs/node_modules/v-markdown-loader/_cache/router-433.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] router-433.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-27509918", Component.options)
  } else {
    hotAPI.reload("data-v-27509918", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2572:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("路由")]), _vm._v(" "), _c('p', [_vm._v("推荐直接使用官方 "), _c('a', {
    attrs: {
      "href": "https://github.com/vuejs/vue-router"
    }
  }, [_vm._v("vue-router")]), _vm._v("，"), _c('code', [_vm._v("VUX")]), _vm._v("部分组件支持"), _c('code', [_vm._v("link")]), _vm._v("属性直接支持"), _c('code', [_vm._v("vue-router")]), _vm._v("的路由参数，"), _c('code', [_vm._v("vux2")]), _vm._v("模板内置了"), _c('code', [_vm._v("vue-router")]), _vm._v("。")]), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_c('p', [_c('del', [_vm._v("如果使用了过渡(转场动画)，在"), _c('code', [_vm._v("iPhone")]), _vm._v("上使用"), _c('code', [_vm._v("左划返回")]), _vm._v("时动画会再执行一遍，目前没有找到可行的处理方法，如果你有处理方案，欢迎"), _c('code', [_vm._v("PR")]), _vm._v("。")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/pull/2259"
    }
  }, [_vm._v("https://github.com/airyland/vux/pull/2259")])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-27509918", module.exports)
  }
}

/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2110);

/***/ })

});


// WEBPACK FOOTER //
// 491.29e8da45.js